import _ from 'lodash';
import React, { useContext, useMemo, useRef, useState } from 'react';
import { Divider, Header, Icon, Label, Segment } from 'semantic-ui-react';
import { formatItem, formatTypes, getFormattedDate } from '../../../../global/common/dateFormatting';
import { uniqueKey } from '../../../../global/common/keys';
import { sortObj, updateArrayInclusion } from '../../../../global/common/sorting';
import { gEnums } from '../../../../global/enums/globalEnums';
import { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { _matchLsTypes } from '../../cnr/reducers/SportsDataReducer';
import { getSectionColor } from '../../create/sectionColors';
import MatchCount from './MatchCount';
import MatchWrapper, { sportsMatchViewTypes } from './MatchWrapper';

const _labelSize = 'tiny'

const matchHeaderIcons = {
  today: 'arrow right',
  todayS: 'arrow down',
  calendar: 'calendar alternate outline',
  list: 'list',
}

const _circulars = {
  matchCount: false,
  playoff: false,
  edit: false,
  today: true,
}

const MatchDateList = ({
  _levelKey,
  accessLevel,
  forOverview,
  forSummary,
  index,
  matchDate,
  matches,
  scheduleTypes,
  scollToRef,
  teamKey,
}) => {

  let headerFormatType;

  const _mdCache = useRef(new Map());
  const _mdeCache = useRef(new Map());

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { sportSettings_info } = sportsSeason_state ?? {}
  const { matchScheduleDisplayType } = sportSettings_info ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state } = seasonMatchesContext ?? {}
  const { tournamentType, levelKey: levelKey_selected, levelDatesKey } = seasonMatches_state ?? {} //lastDatesSelected

  // levelDatesGroup: action.dlg, levelDatesKey: action.dlk, levelKey: action.lk

  switch (matchScheduleDisplayType) {
    case gEnums.matchScheduleDisplayTypes.allDates:
    case gEnums.matchScheduleDisplayTypes.clickedDates:
      headerFormatType = formatTypes.fullDate
      break;
    default:
      headerFormatType = formatTypes.shorterDate
    // nothing
  }

  const [visibleLevelDates, setVisibleLevelDates] = useState({})
  const [lastDatesSelected, setLastDatesSelected] = useState({})

  let _selectedDate = lastDatesSelected && lastDatesSelected[levelKey_selected] ? lastDatesSelected[levelKey_selected] : levelDatesKey

  const handle_setVisibleDates = (levelKey, matchDate) => {
    const _visibleLevelDates = { ...visibleLevelDates }
    const _lastDatesSelected = { ...lastDatesSelected }
    if (!_visibleLevelDates[levelKey]) { _visibleLevelDates[levelKey] = [] }
    _lastDatesSelected[levelKey] = matchDate
    updateArrayInclusion(_visibleLevelDates[levelKey], matchDate)
    setVisibleLevelDates(_visibleLevelDates)
    setLastDatesSelected(_lastDatesSelected)
  }

  const singleMatch = (segs, match, showFavs, keyOrIndex) => {
    const { _status, key, id } = match ?? {}
    const { isBye } = _status ?? {}

    let keyy = key ? key : id
    if (!keyy) { keyy = keyOrIndex }

    // if (keyy === '2WAoKdCy3O4fz9ZmVzFt') {
    //   console.log('sm', match)
    // }

    if (!isBye || showByes) {
      const m = <MatchWrapper
        key={uniqueKey('mls', 'mw', keyy)}
        sportsMatchViewType={sportsMatchViewTypes.single}
        scheduleTypes={scheduleTypes}
        match={match}
        tournamentType={tournamentType}
        teamKey={teamKey}
        forOverview={forOverview}
        forSummary={forSummary}
      />
      segs.push(m)
    }
  }

  const matchList = (currentMatches, showFavs, isFuture) => {

    let segs = []
    let _currentMatches = currentMatches;

    if (_.isArray(currentMatches)) {
      if (currentMatches && _.size(currentMatches) > 0) {
        _.forEach(currentMatches, (match, i) => {
          singleMatch(segs, match, showFavs, i)
        })
      }
    } else {
      if (_currentMatches && _.size(currentMatches) > 0) {
        _.forEach(currentMatches, (match, key) => {
          singleMatch(segs, match, showFavs, key)
        })
      }
    }

    return segs.length > 0 ? segs : <Segment key={uniqueKey('mls', 'ml')} className={'seg-ph-full'} placeholder style={{ height: '100%', textAlign: 'center', fontWeight: 'bold' }}>{isFuture ? 'No Upcoming Matches' : 'No Matches'}</Segment>
  }

  const sectionLabel = (section) => <Label circular size={_labelSize} color={getSectionColor(section)}></Label>

  // LEAVE
  const divider = (value, icon, index, sectionKey) => <Divider key={uniqueKey('mls', 'tm', index, value)} horizontal>
    <Header as='h5'>
      {icon && <Icon name={icon} />}
      {value}
      {sectionKey && sectionLabel(sectionKey)}
    </Header>
  </Divider>

  // LEAVE
  const matchSegs = (sectionSegs, sectionMatchSegs, sectionKey, keyy, index) => {
    sectionSegs.push(<div key={uniqueKey('mls', 'lds', sectionKey)} className={'schedule-section'}>
      {sectionKey && sectionKey !== 'undefined' && divider(_.startCase(sectionKey, index), null, null, sectionKey)}
      <div key={uniqueKey('mls', 'lds', 'st')} className={'schedule-section-teams'}>{sectionMatchSegs}</div>
    </div>)
  }

  const getMatchSegs = (matchInfo, levelKey, _index) => {

    // loop Sections 
    const _segs = {
      section: [],
      nonSection: [],
      nonDistrict: [],
      tournament: [],
    }

    // section matches
    _.forEach(matchInfo.groupedBySectionSorted, (_sectionMatches, sectionKey) => {
      const keyy = levelKey + '-' + sectionKey
      const _sectionMatchesSorted = _.sortBy(_sectionMatches, ['home.name']);
      const sectionMatchSegs = matchList(_sectionMatchesSorted, true)
      matchSegs(_segs.section, sectionMatchSegs, sectionKey, keyy, _index)
    })

    // non section matches
    if (matchInfo.nonSection && _.size(matchInfo.nonSection) > 0) {
      const nonSectionSorted = _.sortBy(matchInfo.nonSection, ['home.name']);
      const _matchList = matchList(nonSectionSorted, true)
      matchSegs(_segs.nonSection, _matchList, 'nonSection', levelKey + '-non', _index)
    }

    // non distcit matches
    if (matchInfo.nonDistrict && _.size(matchInfo.nonDistrict) > 0) {
      const nonDistrictSorted = _.sortBy(matchInfo.nonDistrict, ['home.name']);
      const _matchList = matchList(nonDistrictSorted, true)
      matchSegs(_segs.nonDistrict, _matchList, 'nonDistrict', levelKey + '-non', _index)
    }

    if (matchInfo.tournaments && _.size(matchInfo.tournaments) > 0) {
      const _matchList = matchList(matchInfo.tournaments, true)
      matchSegs(_segs.tournament, _matchList, _matchLsTypes.tournament, levelKey + '-non', _index)
    }

    if (matchInfo.playoff && matchInfo.playoff.length > 0) {
      const _playoffMatches = _.sortBy(matchInfo.playoff, 'matchNumber')
      const _matchList = matchList(_playoffMatches, true)
      matchSegs(_segs.nonSection, _matchList, 'playoff', levelKey + '-non', _index)
    }

    const _matchDateSegs = [..._segs.section, ..._segs.nonSection, ..._segs.nonDistrict]
    return _matchDateSegs

  }

  if (matches) {
    _.forEach(matches, (m) => {
      if (m.sections) {
        m.sections = m.sections.trim();
      }
    });
  }

  const matchesInfo = useMemo(() => {

    const matches_normal = _.filter(matches, (m) => m && !m?._status?.isBye);
    const matches_playoffs = _.filter(matches_normal, (m) => m.isPlayoff);

    matches_normal.forEach((m) => {
      if (m.sections) {
        m.sections = m.sections.trim();
      }
    });

    const pastNonScore = matches ? _.filter(matches, function (m) { return m?._status?.isPast && !m?._status?.isBye && !m._results?.complete; }) : null

    const info = {
      matchDate,
      levelKey: _levelKey,
      inSection: _.filter(matches_normal, (m) =>
        m.away?.sections === m.home?.sections &&
        m.away?.levels === m.home?.levels
      ),
      nonSection: _.filter(matches_normal, (m) =>
        m.levels !== 'nonDistrict' &&
        (m.away?.sections !== m.home?.sections || m.away?.levels !== m.home?.levels)
      ),
      nonDistrict: _.filter(matches_normal, (m) => m.levels === 'nonDistrict'),
      tournaments: _.filter(matches_normal, (m) =>
        m.home?.levels === _matchLsTypes.tournament
      ),
      playoff: matches_playoffs,
      matchCounts: {
        matchCount: matches ? _.size(matches) : 0,
        nrCount: pastNonScore ? _.size(pastNonScore) : 0,
        matchCount_normal: matches_normal ? _.size(matches_normal) : 0,
        matchCount_playoffs: matches_playoffs ? _.size(matches_playoffs) : 0,
      },
      isPlayoffs: false
    };

    info.groupedBySection = _.groupBy(info.inSection, 'sections');
    info.groupedBySectionSorted = sortObj(info.groupedBySection);
    info.isPlayoffs = info.matchCounts.matchCount_normal === info.matchCounts.matchCount_playoffs

    return info;
  }, [matches, _levelKey]);

  const _matchSegs = useMemo(() => {
    return getMatchSegs(matchesInfo, _levelKey, index);
  }, [matchesInfo, _levelKey, index]);

  const handleDateHeaderClick = (matchDate) => handle_setVisibleDates(_levelKey, matchDate)

  const todayLabel = (md, dateSelected) => <Label key={uniqueKey('mls', 'tl', md)} circular={_circulars.today} size={_labelSize} color={'grey'} title={dateSelected ? 'Collapse' : 'Expand'}>
    <Icon name={dateSelected ? matchHeaderIcons.todayS : matchHeaderIcons.today} style={{ margin: 0 }} />
  </Label>

  const noMatchesDiv = () => "---"

  const dateHeader = (matchDate, showCount, matchCounts, dateSelected, _isToday) =>
    <div key={uniqueKey('mls', 'd', levelKey_selected, matchDate)}
      onClick={() => { handleDateHeaderClick(matchDate) }}
      las={levelKey_selected}
      id={matchDate}
      ref={(matchDate === _selectedDate) ? scollToRef : null}
    >
      <div>{formatItem(headerFormatType, matchDate)}</div>
      <div className={'sdw-lbls'}>
        {showCount && <MatchCount matchCounts={matchCounts} />}
        {todayLabel(matchDate, dateSelected)}
      </div>
    </div>


  // matchDateElements - MEMO
  const matchDateElements = useMemo(() => {

    const cache_mde = `${matchDate}-${_levelKey}`;

    if (_mdeCache.current.has(cache_mde)) {
      return _mdeCache.current.get(cache_mde);
    }

    const mdes = (
      <div key={uniqueKey('mls', 'lds', 'sls', matchDate)} className={'schedule-level-section'}>
        {_matchSegs.length > 0 ? _matchSegs : noMatchesDiv()}
      </div>
    )

    _mdeCache.current.set(cache_mde, mdes);
    return mdes

  }, [_matchSegs, matchDate, _levelKey, matchesInfo, accessLevel]);

  const dateElements = useMemo(() => {
    if (_matchSegs.length > 0) {
      const today = getFormattedDate(new Date());
      const mediaCount = 0;
      const _isToday = today === matchDate;

      const isPlayoffs = matchesInfo.isPlayoffs;
      let cn_sections = 'sdw';
      if (isPlayoffs) cn_sections += ' playoffs';

      let showMatches = true;
      let showCount;
      let showMediaCount;

      if (matchScheduleDisplayType === gEnums.matchScheduleDisplayTypes.clickedDates) {
        showMatches = visibleLevelDates?.[_levelKey]?.includes(matchDate);
        showCount = true;
        showMediaCount = true;
      }

      const matchCounts = {
        matchDate,
        ...matchesInfo.matchCounts,
        _isToday,
        showMediaCount,
        mediaCount,
        isPlayoffs,
        allowEdit: accessLevel >= gEnums.accessLevels.superAdmin.value,
      };

      return (
        <div key={uniqueKey('mls', matchDate)} className={cn_sections}>
          {dateHeader(matchDate, showCount, matchCounts, showMatches, _isToday)}
          <div key={uniqueKey('mls', 'lds', 'sl', matchDate)} className={showMatches ? 'schedule-level' : 'schedule-level hid'}>
            {matchDateElements}
          </div>
        </div>
      );
    }

    return _matchSegs;
  }, [_matchSegs, matchDate, matchesInfo, matchScheduleDisplayType, visibleLevelDates, _levelKey, accessLevel, _matchSegs]);

  return dateElements

}

export default MatchDateList